<template>
  <div class="plv-ia-lottery-template">
    <div class="plv-ia-lottery-template-tip">
      <p>
        <span v-if="lotteryingStatus.conditionLotteryStatus || lotteryingStatus.lotteryStatus" class="plv-ia-lottery-template-tip--icon"></span>
        <span v-if="lotteryingStatus.conditionLotteryStatus && lotteryingStatus.lotteryStatus">{{ t('plvIA.lottery.lotteryingStatusTip1') }}</span>
        <span v-else-if="lotteryingStatus.conditionLotteryStatus">{{ t('plvIA.lottery.lotteryingStatusTip2') }}</span>
        <span v-else-if="lotteryingStatus.lotteryStatus">{{ t('plvIA.lottery.lotteryingStatusTip3') }}</span>
      </p>
    </div>
    <div class="plv-ia-lottery-template-table">
      <div class="plv-ia-lottery-template-table-header plv-ia-lottery-template-table-tr">
        <div class="plv-ia-lottery-template-table-td">{{ t('plvIA.lottery.templateLotteryName') }}</div>
        <div class="plv-ia-lottery-template-table-td">{{ t('plvIA.lottery.templateDuration') }}</div>
        <div class="plv-ia-lottery-template-table-td">{{ t('plvIA.lottery.templateCondition') }}</div>
        <div class="plv-ia-lottery-template-table-td">{{ t('plvIA.lottery.templatePrizeName') }}</div>
        <div class="plv-ia-lottery-template-table-td">{{ t('plvIA.lottery.templateAmount') }}</div>
        <div class="plv-ia-lottery-template-table-td">{{ t('plvIA.lottery.templateHandle') }}</div>
      </div>
      <div v-if="templateList.length > 0" class="plv-ia-lottery-template-table-body">
        <div class="plv-ia-lottery-template-table-body--inner">
          <div class="plv-ia-lottery-template-table-tr" v-for="(item, index) in templateList" :key="index">
            <div class="plv-ia-lottery-template-table-td"> {{ item.activityName}}</div>
            <div class="plv-ia-lottery-template-table-td"> {{ item.activityDuration ? item.activityDuration + '分钟' : '/' }}</div>
            <div class="plv-ia-lottery-template-table-td"> {{ translateCondition(item.lotteryCondition)}}</div>
            <div class="plv-ia-lottery-template-table-td"> {{ item.prizeName}}</div>
            <div class="plv-ia-lottery-template-table-td"> {{ item.amount}}</div>
            <div class="plv-ia-lottery-template-table-td">
              <button
                class="plv-ia-lottery-template-table-handle"
                :disabled="disableChoose(item)"
                :class="{'plv-ia-lottery-template-table-handle--disable': disableChoose(item)}"
                @click="choose(item)"
              >
                {{ t('plvIA.lottery.templateChoose') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="plv-ia-lottery-template-table-empty">
        <img src="./images/no-list.png" alt=""/>
        <p>{{ t('plvIA.lottery.noRecord') }}</p>
      </div>
    </div>

    <div class="plv-ia-lottery-template-btn--back plv-ia-lottery-btn" @click="goBack">{{ t('plvIA.lottery.back') }}</div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export default {
  props: {
    core: Object,
    lotteryingStatus: Object,
  },
  mixins: [Locale],
  data() {
    return {
      templateList: [],
    };
  },
  mounted() {
    this.getTemplateList();
  },
  methods: {
    // 抽奖条件类型
    translateCondition(type) {
      let str;
      switch (type) {
        case 'invite': str = this.t('plvIA.lottery.conditionInvite'); break;
        case 'duration': str = this.t('plvIA.lottery.conditionDuration'); break;
        case 'none': str = this.t('plvIA.lottery.conditionNone'); break;
        default: str = type;
      }
      return str;
    },
    // 最多只能存在条件抽奖和非条件抽奖，判断该模板是否可选择
    disableChoose(item) {
      if (item.lotteryCondition !== 'none') {
        return this.lotteryingStatus.conditionLotteryStatus;
      } else {
        return this.lotteryingStatus.lotteryStatus;
      }
    },
    choose(item) {
      this.$emit('choose-template', item);
    },
    goBack() {
      this.$emit('back');
    },
    async getTemplateList() {
      this.templateList = await this.core.searchLotteryTemplate();
    }
  }
};
</script>

<style lang="scss">
.plv-ia-lottery-template {
  width: 100%;
  padding: 24px 16px;
}
.plv-ia-lottery-template-tip {
  color: #9E9E9E;
  font-size: 14px;
  p {
    display: flex;
    align-items: center;
  }
  .plv-ia-lottery-template-tip--icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('./images/icon-tip.png') no-repeat;
    background-size: cover;
    margin-right: 8px;
  }
}

.plv-ia-lottery-template-table {
  margin-top: 12px;
  height: 330px;
  display: flex;
  flex-direction: column;
  .plv-ia-lottery-template-table-tr {
    display: flex;
    background: #EDF1F7;
    height: 38px;
    line-height: 38px;
    color: #333333;
    .plv-ia-lottery-template-table-td {
      text-align: center;
      width: 90px;
      white-space: nowrap;/* 规定文本是否折行 */
      overflow: hidden;/* 规定超出内容宽度的元素隐藏 */
      text-overflow: ellipsis;
    }
  }
  .plv-ia-lottery-template-table-td:first-child {
    flex: 1;
  }
  .plv-ia-lottery-template-table-body {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 292px;
    position: relative;
    .plv-ia-lottery-template-table-body--inner {
      width: 688px;
      position: absolute;
      left: 0;
      right: 0;
    }
    .plv-ia-lottery-template-table-tr:nth-child(2n - 1) {
      background: #ffffff;
    }
    .plv-ia-lottery-template-table-tr {
      height: 48px;
      line-height: 48px;
      color: #546E7A;
    }
    .plv-ia-lottery-template-table-handle {
      cursor: pointer;
      color: #2196F3;
      border: none;
      background: inherit;
    }
    .plv-ia-lottery-template-table-handle--disable {
      cursor: default;
      color: #9E9E9E;
    }
  }
}
.plv-ia-lottery-template-btn--back {
  width: 96px;
  text-align: center;
  margin: 20px auto auto;
}

.plv-ia-lottery-template-table-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  img {
    width: 64px;
    height: 64px;
  }
}

</style>
